<template>
  <div>  
      <img
      class="img-fluid"
      src="https://tom.imgix.net/vuetube.png?auto=format,compress&w=480"/>  
      <input type="text" @keydown.enter="onInput" />
  </div>
</template>

<script>
export default {
    name: 'SearchBar',
    methods: {
        onInput: function(event) {
            this.$emit('termChange', event.target.value);
        }
    }
};
</script>

<style scoped>
  input {
      width: 75%;
  }

  div {
      text-align: center;
      margin: 20px;
  }

  .img-fluid {
      max-width: 75%;
  }
</style>